/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import {
  questionnairesXmlPost,
  QuestionnairesXmlPostParams
} from '../fn/questionnaire/questionnaires-xml-post';
import {questionnairesGet, QuestionnairesGetParams} from "../fn/questionnaire/questionnaires-get";
import {QuestionnaireModel} from "../models/questionnaire-model";
import {questionnaireSendInvitesPost, QuestionnaireSendInvitesPostParams} from "../fn/questionnaire/send-invites-post";
import {AuthService} from "../../services/auth.service";
import {questionnairesJsonPost, QuestionnairesJsonPostParams} from "../fn/questionnaire/questionnaires-json-post";
import {questionnairesJsonPut} from "../fn/questionnaire/questionnaires-json-put";
import {
  questionnaireBuilderModelGet,
  QuestionnaireBuilderModelGetParams
} from "../fn/questionnaire/questionnaire-builder-model-get";
import {BuilderQuestionnaire} from "../../classes/questionnaire-builder/builder-questionnaire";
import {questionnaireSettingsPut, QuestionnaireSettingsPutParams} from "../fn/questionnaire/questionnaire-settings-put";
import {questionnaireSettingsGet, QuestionnaireSettingsGetParams} from "../fn/questionnaire/questionnaire-settings-get";
import {QuestionnaireSettingsModel} from "../models/questionnaire-settings-model";
import {
  questionnaireResultsCsvGet,
  QuestionnaireResultsCsvGetParams
} from "../fn/questionnaire/questionnaire-results-csv-get";
import {InviteLinkModel} from "../models/invite-link-model";
import {questionnaireVersionsGet, QuestionnaireVersionsGetParams} from "../fn/questionnaire/questionnaire-versions-get";
import {QuestionnaireVersionModel} from "../models/questionnaire-version-model";
import {
  questionnaireArchivePost,
  QuestionnaireArchivePostParams
} from "../fn/questionnaire/questionnaire-archive-post";

@Injectable({ providedIn: 'root' })
export class QuestionnaireService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient, authService: AuthService) {
    super(config, http);
  }

  /** Path part for operation `apiV1QuestionnairesXmlPost()` */
  static readonly QuestionnairesXmlPostPath = '/api/v1/questionnaires/xml';

  /**
   * Converts an Xml file into a new questionnaire entity, inserts it into the database, and returns a model
   * representing the newly created questionnaire.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1QuestionnairesXmlPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  questionnairesXmlPost$Response(params: QuestionnairesXmlPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return questionnairesXmlPost(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * Converts an Xml file into a new questionnaire entity, inserts it into the database, and returns a model
   * representing the newly created questionnaire.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1QuestionnairesXmlPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  questionnairesXmlPost(params: QuestionnairesXmlPostParams, headers: HttpHeaders, context?: HttpContext): Observable<void> {
    return this.questionnairesXmlPost$Response(params, headers, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV1QuestionnairesXmlPost()` */
  static readonly QuestionnairesJsonPostPath = '/api/v1/questionnaires/json';

  /**
   * Converts a JSON builder model from the KQ questionnaire builder into a questionnaire entity, inserts it
   * into the database, and returns a Guid for the newly created questionnaire
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnairesJsonPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  questionnairesJsonPost$Response(params: QuestionnairesJsonPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireModel>> {
    return questionnairesJsonPost(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * Converts a JSON builder model from the KQ questionnaire builder into a questionnaire entity, inserts it
   * into the database, and returns a Guid for the newly created questionnaire
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnairesJsonPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  questionnairesJsonPost(params: QuestionnairesJsonPostParams, headers: HttpHeaders, context?: HttpContext): Observable<QuestionnaireModel> {
    return this.questionnairesJsonPost$Response(params, headers, context).pipe(
        map((r: StrictHttpResponse<QuestionnaireModel>): QuestionnaireModel => r.body)
    );
  }

  /** Path part for operation `apiV1QuestionnairesXmlPost()` */
  static readonly QuestionnairesJsonPutPath = '/api/v1/questionnaires/json';

  /**
   * Updates an existing questionnaire created via the questionnaire builder
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnairesJsonPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  questionnairesJsonPut$Response(params: QuestionnairesJsonPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireModel>> {
    return questionnairesJsonPut(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * Updates an existing questionnaire created via the questionnaire builder
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnairesJsonPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  questionnairesJsonPut(params: QuestionnairesJsonPostParams, headers: HttpHeaders, context?: HttpContext): Observable<QuestionnaireModel> {
    return this.questionnairesJsonPut$Response(params, headers, context).pipe(
        map((r: StrictHttpResponse<QuestionnaireModel>): QuestionnaireModel => r.body)
    );
  }

  static readonly QuestionnairesGetPath = '/api/v1/questionnaires';

  /**
   * Lists available questionnaires
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnairesGet()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnairesGet$Response(headers: HttpHeaders, params: QuestionnairesGetParams, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireModel[]>> {
    return questionnairesGet(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * Lists available questionnaires
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnairesGet$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnairesGet(headers: HttpHeaders, params: QuestionnairesGetParams, context?: HttpContext): Observable<QuestionnaireModel[]> {
    return this.questionnairesGet$Response(headers, params, context).pipe(
        map((r: StrictHttpResponse<QuestionnaireModel[]>): QuestionnaireModel[] => r.body)
    );
  }

  static readonly QuestionnaireArchivePostPath = '/api/v1/questionnaires/{questionnaireGuid}/archive';

  /**
   * Archives a questionnaire so it is hidden from normal lists and cannot be edited.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnaireArchivePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnaireArchivePost$Response(params: QuestionnaireArchivePostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return questionnaireArchivePost(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * Archives a questionnaire so it is hidden from normal lists and cannot be edited.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnaireArchivePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnaireArchivePost(params: QuestionnaireArchivePostParams, headers: HttpHeaders, context?: HttpContext): Observable<void> {
    return this.questionnaireArchivePost$Response(params, headers, context).pipe(
        map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /**
   * For a given questionnaire, gets a builder model which can be consumed by the questionnaire builder to
   * make edits to the questionnaire
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnaireBuilderModelGet()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnaireBuilderModelGet$Response(headers: HttpHeaders, params: QuestionnaireBuilderModelGetParams, context?: HttpContext): Observable<StrictHttpResponse<BuilderQuestionnaire>> {
    return questionnaireBuilderModelGet(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * For a given questionnaire, gets a builder model which can be consumed by the questionnaire builder to
   * make edits to the questionnaire
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnaireBuilderModelGet$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnaireBuilderModelGet(headers: HttpHeaders, params: QuestionnaireBuilderModelGetParams, context?: HttpContext): Observable<BuilderQuestionnaire> {
    return this.questionnaireBuilderModelGet$Response(headers, params, context).pipe(
        map((r: StrictHttpResponse<BuilderQuestionnaire>): BuilderQuestionnaire => r.body)
    );
  }

  /**
   * Sends questionnaire invites
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnairesSendInvitesPost$Response(params: QuestionnaireSendInvitesPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<InviteLinkModel[]>> {
    return questionnaireSendInvitesPost(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * Updates the settings for the questionnaire
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnaireSettingsPut$Response(params: QuestionnaireSettingsPutParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return questionnaireSettingsPut(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * Gets the settings for the questionnaire
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnaireSettingsGet()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnaireSettingsGet$Response(params: QuestionnaireSettingsGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireSettingsModel>> {
    return questionnaireSettingsGet(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * Gets the settings for the questionnaire
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnaireSettingsGet$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnaireSettingsGet(params: QuestionnaireSettingsGetParams, headers: HttpHeaders, context?: HttpContext): Observable<QuestionnaireSettingsModel> {
    return this.questionnaireSettingsGet$Response(params, headers, context).pipe(
        map((r: StrictHttpResponse<QuestionnaireSettingsModel>): QuestionnaireSettingsModel => r.body)
    );
  }

  /**
   * Returns a CSV file containing questionnaire results
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionnaireResultsCsvGet()` instead.
   *
   * This method sends `application/json` and handles request body of type `text/csv`
   */
  questionnaireResultsCsvGet$Response(params: QuestionnaireResultsCsvGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return questionnaireResultsCsvGet(this.http, this.rootUrl, params, headers, context);
  }

  /**
   * Returns a CSV file containing questionnaire results
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionnaireResultsCsvGet$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `text/csv`
   */
  questionnaireResultsCsvGet(params: QuestionnaireResultsCsvGetParams, headers: HttpHeaders, context?: HttpContext): Observable<Blob> {
    return this.questionnaireResultsCsvGet$Response(params, headers, context).pipe(
        map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Gets all versions for the questionnaire
   *
   *
   *
   * This method provides access only to the response body.
   *
   * This method sends `application/json` and handles request body of type `application/json`
   */
  questionnaireVersionsGet(params: QuestionnaireVersionsGetParams, headers: HttpHeaders, context?: HttpContext): Observable<QuestionnaireVersionModel[]> {
    return questionnaireVersionsGet(this.http, this.rootUrl, params, headers, context).pipe(
        map((r: StrictHttpResponse<QuestionnaireVersionModel[]>): QuestionnaireVersionModel[] => r.body)
    );
  }
}
